import FormInputText from './component.jsx'
export default FormInputText
